function changeDocumentTitle(title) {
  if (title) {
    document.title = title;
  }
}

export { changeDocumentTitle };
